module.exports = __webpack_public_path__ + "static/media/LearnCreatorImpactAssess.5dbf2477.png";